import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useToast } from "../hooks/use-toast";
import logo from "../assets/logo.png";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(form);
    setLoading(false);
    if (res.error) { toast({ title: res.error, variant: "destructive" }); return; }
    toast({ title: `Welcome back, ${(res.user.name || "there").split(" ")[0]}!` });
    navigate(res.user.role === "admin" ? "/admin" : "/");
  };

  return (
    <div className="min-h-screen hero-dark grid place-items-center px-5 py-20">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-8">
        <div className="flex items-center gap-2 justify-center mb-6">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-white border border-slate-100 overflow-hidden"><img src={logo} alt="Flycher Travels" className="w-full h-full object-contain p-0.5" /></span>
          <span className="font-display font-bold text-lg text-slate-900">Flycher Travels</span>
        </div>
        <h1 className="text-2xl font-bold text-slate-900 text-center">Welcome back</h1>
        <p className="text-sm text-slate-500 text-center mt-1">Log in to manage your trips.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label>Email</Label><Input value={form.email} onChange={set("email")} type="email" className="mt-1" placeholder="you@email.com" /></div>
          <div><Label>Password</Label><Input value={form.password} onChange={set("password")} type="password" className="mt-1" placeholder="••••••••" /></div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-coral-600 hover:bg-coral-700 text-white">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Log in"}
          </Button>
        </form>
        <p className="mt-5 text-center text-sm text-slate-500">
          New here? <Link to="/register" className="text-coral-600 font-semibold">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
